import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {AuthGuard} from '@core/service/auth.guard';
import {WelfyContainerComponent} from '@feature-module/welfy-container/welfy-container.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'login',
        loadChildren: () =>
          import('@feature-module/login/login.module').then(
            (value) => value.LoginModule
          ),
      },
    ],
  },
  {
    path: '',
    component: WelfyContainerComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'simulations',
        children: [
          {
            path: 'family',
            loadChildren: () => import('../app/welfy-plugin/welfy/welfy.module').then(value => value.WelfyModule),
          },
          {
            path: 'business',
            loadChildren: () => import('../app/welfy-plugin/welfybusiness/welfybusiness.module').then(value => value.WelfybusinessModule),
          },
          {
            path: 'light',
            loadChildren: () => import('../app/feature-modules/simulations/welfylight/welfy-ligth.module').then(value => value.WelfyLigthModule),
          }
        ]
      },
      {
        path: 'collaborators',
        loadChildren: () => import('../app/feature-modules/user/user.module').then(value => value.UserModule)
      },
    ],
  },
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
